export const viewContentGoogleAnalythicEvent = () => {
  window.gtag("event", "view_content");
};

export const purchaseGoogleAnalythicEvent = () => {
  window.gtag("event", "purchase");
};
